import { useEffect, useState } from 'react';
import { useUiStore } from '@/stores/ui';

/**
 * Single source of truth for "should this animate?". Components branch on this
 * rather than reading matchMedia directly, so the in-app setting and the OS
 * preference stay in agreement.
 */
export function useMotionPrefs(): { reduced: boolean } {
  const pref = useUiStore((s) => s.motion);
  const [systemReduced, setSystemReduced] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const onChange = (e: MediaQueryListEvent): void => setSystemReduced(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return { reduced: pref === 'reduced' || systemReduced };
}
